import React, {Component} from "react";
import MusicGrid from '../../components/MusicGrid';
import RequestManager from './../../requests/RequestManager';
import Placeholder from '../../containers/Placeholder';
import ListTask from './../../requests/tasks/epg/ChannelsTask';
import { connect } from 'react-redux';
import MusicUtils from "../../actions/musica/music-actions";

class MusicStations extends Component {
  constructor(props){

    super (props);
    this.state = {
      purchaseButtonInfo: null,
      user: props.user.musicUser,
      itemData: {},
      isFetching: false,
      topRadios: [],
      totalRadios: [],
      index: 0,
      size: 30,
      showMyContentPlaceholder: false,
      filterId: 31675,
    };
  }

  request(params, callback) {
    
    const paramss = {
      filter_inactive: 0,
        filter_id: this.state.filterId,
        quantity: 400,
        from: 0,
        level_id: 'GPS'
    };


    try {
      const task = new ListTask(paramss);
      RequestManager.addRequest(task, paramss).then((response) => {
        const radios = MusicUtils.transformStringrayRadios(response.response.groups, this.state.filterId);
        this.setState({
          topRadios: radios,
        });
        if (typeof callback === 'function') {
          callback(response.response);
        }
      });
    } catch (e) {
      console.error('error getting Level in', e);
    }
  }

  componentDidMount() {
    this.request();
  }
  render() {
    if (!this.state.showMyContentPlaceholder) {
      return (
        <div className="">
          <MusicGrid
            items={this.state.topRadios}
            onFocusHandler={this.props.onFocusCardHandler}
            gridType="radio"
            type="square"
            service={this.props.service}
          />
        </div>
      )
    } else {
      return(
        <Placeholder
          type={'radiosSection'}
        />
      );
    }
  }
}

export default connect(null, null,  null, { withRef: true })(MusicStations);



// WEBPACK FOOTER //
// ./src/containers/Stringray/stringrayStations.jsx